import { render } from "./GiftsSection.vue?vue&type=template&id=896fd39a&scoped=true"
import script from "./GiftsSection.vue?vue&type=script&lang=js"
export * from "./GiftsSection.vue?vue&type=script&lang=js"

import "./GiftsSection.vue?vue&type=style&index=0&id=896fd39a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896fd39a"]])

export default __exports__